import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { drapcodeIcon, iconForField } from '../../../common/custom/icon-library';
import CustomLoader from '../../common/CustomLoader';
export default class CustomCSSCDNForm extends Component {
  static propTypes = {
    handleCustomCssCdnSubmit: PropTypes.func.isRequired,
  };
  state = {
    enableAddCssUrl: false,
  };

  clearForm = () => {
    this.setState({
      schema: {},
      enableAddCssUrl: false,
    });
  };

  validateUrl = (value) => {
    if (!value || value.length === 0) {
      this.setState({ enableAddCssUrl: false });
      return 'URL or a <link> tag is required';
    }

    const urlRegEx =
      /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

    if (!urlRegEx.test(value)) {
      if (!value.startsWith('<link') || !value.includes('href')) {
        this.setState({ enableAddCssUrl: false });
        return 'Not a valid URL or a <link> tag';
      }
    }

    this.setState({ enableAddCssUrl: true });
  };

  validateSortOrder = (value) => {
    const numberRegEx = /^\d+$/;
    if (value && !numberRegEx.test(value)) {
      this.setState({ enableAddCssUrl: false });
      return 'Sort Order value is not valid';
    }
  };

  createSchemaCustomCssCdn = () => {
    const { customCssCdns, customCssCdnUuid } = this.props;
    let customCssCdn =
      customCssCdns && customCssCdns.find((customCssCdn) => customCssCdn.uuid === customCssCdnUuid);

    let schema = {};
    schema['customCssUrlOrTag'] = customCssCdn ? customCssCdn.urlOrTag : '';
    schema['loadToBuilder'] = customCssCdn ? customCssCdn.loadToBuilder : true;
    schema['sortOrder'] = customCssCdn ? customCssCdn.sortOrder : '';
    return schema;
  };

  handleCSSCdnSubmit = (values) => {
    const { customCssCdnUuid } = this.props;

    const customCssCdnsFlattenContent =
      values && values.customCssUrlOrTag ? values.customCssUrlOrTag.trim() : '';
    const customType = customCssCdnsFlattenContent.startsWith('<link') ? 'TAG' : 'URL';
    if (customCssCdnUuid) {
      this.props.handleCustomCssCdnSubmit({
        customCssUrlOrTag: customCssCdnsFlattenContent,
        loadToBuilder: values.loadToBuilder,
        sortOrder: values.sortOrder ? values.sortOrder : 0,
        uuid: customCssCdnUuid,
        customType,
      });
    } else {
      this.props.handleCustomCssCdnSubmit({
        customCssUrlOrTag: customCssCdnsFlattenContent,
        loadToBuilder: values.loadToBuilder,
        sortOrder: values.sortOrder ? values.sortOrder : 0,
        customType,
      });
    }
  };

  render() {
    const { showCustomCSSUrlLoader, isCssCdnCreate, isReadOnly } = this.props;
    return (
      <>
        <Formik
          initialValues={this.createSchemaCustomCssCdn()}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            !isReadOnly && this.handleCSSCdnSubmit(values);
            setSubmitting(false);
            resetForm();
            this.clearForm();
            this.props.closeNewCustomCSSCdn();
          }}
        >
          {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
            return (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend" title="CSS URL or a <link> tag">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('url')}`}></i>
                            <span className="required"> *</span>
                          </span>
                        </div>
                        <Field
                          name="customCssUrlOrTag"
                          className="form-control form-control-sm"
                          placeholder="Insert your CSS URL or a <link> tag here.."
                          validate={this.validateUrl}
                        />
                        <ErrorMessage name="customCssUrlOrTag">
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend" title="Load to Builder Canvas">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                            <span className="required"> *</span>
                          </span>
                        </div>

                        <div className="form-check">
                          <label className="form-check-label">
                            <Field
                              type="checkbox"
                              name="loadToBuilder"
                              className="form-check-input"
                              title="Load to Builder Canvas"
                            />
                            Load to Builder Canvas
                            <span className="form-check-sign">
                              <span className="check"></span>
                            </span>
                          </label>
                          <p className="errors">
                            <ErrorMessage name="loadToBuilder" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend" title="Order">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('number')}`}></i>
                            <span className="required"> *</span>
                          </span>
                        </div>
                        <Field
                          name="sortOrder"
                          className="form-control form-control-sm"
                          placeholder="Sort Order value (Default: 0)"
                          validate={this.validateSortOrder}
                        />
                        <ErrorMessage name="sortOrder">
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 text-right">
                    <button
                      type="reset"
                      className="btn btn-default btn-md"
                      onClick={() => {
                        resetForm();
                        this.props.closeNewCustomCSSCdn();
                      }}
                    >
                      <span>
                        <i className={`wb ${drapcodeIcon('cancel')}`}></i>&nbsp;Cancel
                      </span>
                    </button>
                    &nbsp;
                    {isCssCdnCreate ? (
                      <button
                        type={`${this.state.enableAddCssUrl ? 'submit' : 'button'}`}
                        className={`btn btn-md ${
                          this.state.enableAddCssUrl ? 'btn-theme-submit' : 'btn-default disabled'
                        }`}
                        disabled={
                          (isSubmitting && showCustomCSSUrlLoader) || isReadOnly ? 'disabled' : ''
                        }
                        title={isReadOnly ? 'Read Only' : 'Add CSS URL/Link Tag'}
                      >
                        <i className={`wb ${drapcodeIcon('create')}`}></i>&nbsp;
                        {isCssCdnCreate ? 'Add' : 'Update'} CSS URL/Link Tag&nbsp;
                        <CustomLoader loading={showCustomCSSUrlLoader} />
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-md"
                        disabled={
                          (isSubmitting && showCustomCSSUrlLoader) || isReadOnly ? 'disabled' : ''
                        }
                        title={isReadOnly ? 'Read Only' : 'Update CSS URL/Link Tag'}
                      >
                        <i className={`wb ${drapcodeIcon('update')}`}></i>&nbsp;Update
                        <CustomLoader loading={showCustomCSSUrlLoader} />
                      </button>
                    )}
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  }
}
